export const KnowledgeTypes = {
  IMPORT: 'import',
  DOWNLOAD: 'download',
  DOWNLOAD_TEMPLATE: 'downloadTemplate',
  WARNING_CIRCLE: 'warningCircle',
  DELETE: 'delete',
  DUPLICATE: 'content_copy',
  REPLACE: 'published_with_changes',
};

export const regexFileExtension  = /(?:\.([^.]+))?$/;
export const regexSplitByDash = /-(.+)/;
export const regexFindDoubleQuotes = /"/g;
export const regexFindDuplicatedEndString = /\(\d*?\)/;
export const regexFindDigits = /\d+/g;
export const regexFindDot = /\./g;

export const competencyTitleKeyPrefixDelimitor = 'DOT';

export const escapeDoubleQuotation = '\\"';

export const doubleQuotes = '""';

export const underScoreSeparator = '_';

export const KnowledgeMapCsvTemplateFileName = 'KnowledgeMap_Template.csv';

export const knowledgeMapPdfDocumentationFileName = 'Information on 1-level & 2-level objectives.pdf';

export const KnowledgeMapIconIds = {
  SUBMIT_INPUT: 'check',
  PANEL_CLOSE: 'close',
  EDIT_INPUT: 'edit',
  ADD_INPUT: 'add',
  CONTENT_COPY: 'content_copy',
  DELETE: 'delete',
  FILE_DOWNLOAD: 'file_download',
};

export const knowledgeMapDetailInputStates = {
  ABBREVIATEDSTATEMENT: 'abbreviatedStatement',
  FULLSTATEMENT: 'fullStatement',
  HUMANCODINGSCHEME: 'humanCodingScheme',
  TITLEKEY: 'titleKey',
};

export const KnowledgeMapColumnHeaders = {
  ID: 'ID',
  LEARNING_OBJECTIVE_TITLE: 'LO title',
  ENABLING_OBJECTIVE_TITLE: 'EO title',
  EO_LO_RELATION: 'What is the LO for this EO',
  DESCRIPTION: 'Description',
  SHORTCODE: 'Short Code',
};

export const KnowledgeMapFilenamePrefix = 'KnowledgeMap_';

export const KnowledgeMapErrorMessageKeys = {
  KEY: 'Key',
  VALUE: 'Value',
  DUPLICATETITLE: 'DuplicateTitle',
  SHORTCODEVALUE: 'ShortCodeValue',
  DESCRIPTIONCODEVALUE:'DescriptionCodeValue',
  LONGSHORTCODE: 'LongShortCode',
  LONGDESCRIPTION: 'LongDescription',
  DUPLICATESHORTCODE: 'DuplicateShortCode',
  MISSINGTITLE: 'MissingTitle',
  INVALIDPARENT: 'InvalidParent',
  PARENTMISSINGCHILDTITLE: 'ParentMissingChildTitle',
  MISSINGPARENTANDCHILD: 'MissingParentAndChild',
  LONGENABLINGOBJECTIVETITLE: 'LongEnablingObjectiveTitle',
  LONGLEARNINGOBJECTIVETITLE: 'LongLearningObjectiveTitle',
  CHILDMISSINGPARENTTITLE:'ChildMissingParentTitle',
  ISLEARNINGOBJECTIVEPRESENT: 'IsLearningObjectivePresent',
  INVALIDLOEORELATION: 'InvalidLOEORelation',
};

export const errorMessageKeys = {
  DuplicateTitle: 'knowledgeMapDuplicateTitleFields',
  DuplicateShortCode: 'knowledgeMapDuplicateShortCode',
  InvalidParent: 'knowledgeMapInvalidParentTitle',
  LongShortCode: 'knowledgeMapLongShortCode',
  LongDescription: 'knowledgeMapLongDescription',
  MissingTitle: 'knowledgeMapMissingTitleFields',
  ParentMissingChildTitle: 'knowledgeMapParentMissingChildTitle',
  LongLearningObjectiveTitle: 'knowledgeMapLongLearningObjectiveTitle',
  LongEnablingObjectiveTitle: 'knowledgeMapLongEnablingObjectiveTitle',
  ChildMissingParentTitle: 'knowledgeMapChildMissingParentTitle',
  IsLearningObjectivePresent: 'LearningObjectiveTitlePresent',
  InvalidLOEORelation: 'invalidLOEORelationPresent',
};

export const PRESENTATION_ROLE = 'presentation';

export const DESTINATION_ITEM_ID = 'destinationItemId';

export const ORIGIN_ITEM_ID = 'originItemId';

export const MAXIMUM_SHORT_CODE_LENGTH = 32;

export const MAXIMUM_TITLE_LENGTH = 300;

export const MAXIMUM_DESCRIPTION_LENGTH = 300;

export const competencyDocumentItemPrefixes = {
  COMPETENCY_DOCUMENT_ITEM_COPY_TEXT: 'copy of',
  COMPETENCY_DOCUMENT_ITEM_PARENT_KEY: 'P',
  COMPETENCY_DOCUMENT_ITEM_CHILD_KEY: 'C',
};

export const competencyDocumentItemSufixes = {
  OPENBRACKET: '(',
  CLOSEBRACKET: ')',
  COPY_TEXT_NUMBER:'1',
  UNDER_SCORE:'_',
};

export const InputKeys = {
  ESCAPE_KEY: 'Escape',
  ENTER_KEY: 'Enter',
};

export const KnowledgeMapDownloadOptions = {
  TEMPLATE_DOWNLOAD: 'Template',
  INFORMATION_DOWNLOAD: 'Information',
};

export const queryObjectType = {
  WORKSPACE: 'Workspace',
  DOCUMENT: 'Document',
  DOCUMENT_EDGE: 'DocumentEdge',
  DOCUMENT_ITEM: 'DocumentItem',
  DOCUMENT_ITEM_EDGE: 'DocumentItemEdge',
  ITEM_ASSOCIATION_EDGE: 'ItemAssociationEdge',
  ITEM_ASSOCIATION: 'ItemAssociation',
  ITEM_ASSOCIATION_CONNECTION: 'ItemAssociationConnection',
};

export const competencyItemGraphqlCache = {
  COMPETENCY_ITEM_LIST_UPDATE: 'CompetencyItemListUpdate',
  COMPETENCY_ITEM_ASSOCIATION_UPDATE: 'CompetencyItemAssociationUpdate',
  COMPETENCY_ITEM_DELETE: 'CompetencyItemDelete',
  COMPETENCY_ITEM_LIST_REPLACE: 'CompetencyItemListReplace',
  COMPETENCY_ITEM_ASSOCIATION_REPLACE:'CompetencyItemAssociationReplace',
  COMPETENCY_ITEM_DELETE_ALL: 'CompetencyItemDeleteAll',
};

export const competencyItemAttributes = {
  ITEM_ID_ATTRIBUTE: 'id',
  ORIGIN_ITEM_ID_ATTRIBUTE: 'originItemId',
};

export const PARENT = 'parent';
export const CHILD = 'child';
export const FIRST_CHILD = 'C1';

export const KnowledgeDataFilter = {
  FIND_FULL: 'Full',
  FIND_LINKED_OBJECTIVES: 'Objectives',
};

export default KnowledgeTypes;
